import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Accessories, AccessoryViewModel, BankPortalService, CreateSupportCommand, MerchantAccessoriesAndSupportRequestVm, MerchantAccessoriesRequestViewModel, MerchantSupport, PosHistoryViewModel } from '../../../web-api-client';
import { Permission } from '../../../auth/permissions';
import { SupportRequest } from '../../../core/models/bankportal.model';
import { PosHistory } from '../../../core/models/posHistory/pos-history.model';
import { SupportEdit } from '../../../core/models/support/support-edit.model';
import { Support } from '../../../core/models/support/support.model';
import { Utilities } from '../../../core/models/utilities';
import { MerchantAccessoriesRequest } from '../merchant-accessories-request/merchant-accessories-request.component';
import { MerchantSupportRequest } from '../merchant-support-request/merchant-support-request.component';
import { BankPortalAuthService } from './../../../core/services/bankportal-auth.service';


type AOA = any[][];

@Component({
  selector: 'banksupport',
  templateUrl: './support-and-accessories-request.component.html'
})
export class SupportAndAccessoriesRequest implements OnInit {
  supportRequestForm!: FormGroup;
  public supportForm!: FormGroup;
  rows: PosHistoryViewModel[] = [];
  roworiginal: PosHistoryViewModel[] = [];
  rowsCache: PosHistoryViewModel[] = [];
  rowsSupport: Support[] = [];
  submitted: boolean = false;
  rowsSupportCache: Support[] = [];
  editRow = new PosHistoryViewModel();
  supportEdit = new SupportEdit();
  columnDefs: any[] = [];
  public addSupport: boolean = false;
  public selectedRadio: any;
  uploadTypeValueChanges: EventEmitter<any> = new EventEmitter();
  issueType = [
    { value: 1, text: 'Accessories' },
    { value: 2, text: 'Hardware Issue' },
    { value: 3, text: 'Operation Assistance' },
    { value: 4, text: 'Power Issue' },
    { value: 5, text: 'Settlement Issue' },
    { value: 6, text: 'Technical Issue' }
  ];

  file: any;
  arrayBuffer: any;
  filelist!: any[];
  public gridApi;
  private gridColumnApi;
  IsShowGrid: boolean = false;
  public defaultColDef;
  public rowSelection;
  public editIndex!: number;
  public uploadType: number;
  public addedRow: Array<any> = new Array<any>();
  public isUpdate: boolean = false;

  public editted: boolean = false;
  private selectedLink: string = "no";
  private showRadioButton = false
  isReqSave: boolean = false;
  accessoriesList: AccessoryViewModel[] = [];
  radioItems: Array<any> = new Array<any>();
  @ViewChild(MerchantSupportRequest, { static: false }) merchantSupportReq!: MerchantSupportRequest;

  @ViewChild(MerchantAccessoriesRequest, { static: false }) merchantAccessoriesReq!: MerchantAccessoriesRequest;

  connectivityList = [
    { value: 1, option: 'ETHERNET' },
    { value: 2, option: 'GPRS' },
    { value: 3, option: 'PSTN' },
    { value: 4, option: 'UNKNOWN' },
    { value: 5, option: 'WIFI' }
  ];

  quickSearchValue: any;

  constructor(private formBuilder: UntypedFormBuilder,
    private _el: ElementRef,
    private bankPortalService: BankPortalService,
    private bankPortalAuthService: BankPortalAuthService,
    private _toastr: ToastrService) {
    this.radioItems = [
      { id: 1, type: "Support Request" },
      { id: 2, type: "Accessories Request" },
      { id: 3, type: 'Both' }];

    this.uploadType = 3;

  }

  fileName: string = 'Upload_Format.xlsx';
  data: AOA = [['MERCHANT NAME', 'MERCHANT ID', 'TERMINAL ID', 'TERMINAL TYPE', 'SERIAL KEY', 'CONNECTIVITY', 'CONTACT PERSON', 'CONTACT NO', 'ISSUE', 'REMARKS']];
  public accessoriesRequestForm!: FormGroup;
  public supportAndAccessoriesRequestForm!: FormGroup;
  showExcelData: boolean = false;
  dataForExcel = new SupportRequest();
  dataFromExcel: SupportRequest[] = [];
  public supRequest = new SupportRequest();
  public supportRequestList: Array<SupportRequest> = new Array<SupportRequest>();

  ngOnInit() {
    this.loadPosHistorysData();
    this.loadTerminalData();
    this.columnDefs = [
      {
        headerName: 'Deployed Date', field: 'deployDate', valueFormatter: (data) => moment(data.value).format('ll'), width: 128, suppressSizeToFit: true, filter: 'date',
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            //using moment js
            var dateAsString = moment(cellValue).format('DD/MM/YYYY');
            var dateParts = dateAsString.split("/");
            var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          }
        }
      },
      { headerName: 'Merchant', field: 'merchant', width: 250, suppressSizeToFit: true },
      { headerName: 'Terminal ID', field: 'idTerminal', width: 150, suppressSizeToFit: true },
      { headerName: 'Merchant ID', field: 'idMerchant', width: 150, suppressSizeToFit: true },
      { headerName: 'Address', field: 'address', width: 180, suppressSizeToFit: true },
      { headerName: 'District', field: 'district', width: 130, suppressSizeToFit: true },
      { headerName: 'Province', field: 'province', width: 150, suppressSizeToFit: true },
      { headerName: 'Model', field: 'item', width: 140, suppressSizeToFit: true },
      { headerName: 'Serial Number', field: 'serialKey', width: 250, suppressSizeToFit: true },
      { headerName: 'Application Date', field: 'applicationFormat', width: 180, suppressSizeToFit: true },
      { headerName: 'Connectivity', field: 'connectivity', width: 150, suppressSizeToFit: true, cellRenderer: this.connectivityType(this.connectivityList) },
      { headerName: 'Deployed Location', field: 'merchantLocation', width: 180, suppressSizeToFit: true },
      { headerName: 'Contact Person', field: 'contactPerson', width: 150, suppressSizeToFit: true },
      { headerName: 'Contact No', field: 'contactNo1', width: 150, suppressSizeToFit: true },


    ];
    this.columnDefs.push({
      headerName: "Actions",
      suppressMenu: true,
      field: 'requestName',
      suppressSorting: true,
      width: 250,

      cellRenderer: this.actions(this.bankPortalAuthService),

    });

    this.supportAndAccessoriesRequestForm = this.formBuilder.group({
      supportForm: this.formBuilder.group({
        contactPerson: ['', [Validators.required]],
        contactNo: ['', [Validators.required]],
        issue: ['', [Validators.required]],
        remarks: [''],
        priority: [false],
        isFieldSupport: [false, [Validators.required]],
      }),
      accesoriesForm: this.formBuilder.group({
        itemRows: this.formBuilder.array([this.initItemRows()])
      })
    })

  }
  get f() { return this.supportAndAccessoriesRequestForm.controls; }

  get itemRows(): UntypedFormArray {
    return this.supportAndAccessoriesRequestForm?.get('accesoriesForm')?.get('itemRows') as UntypedFormArray;
  }

  initItemRows() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      inventoryId: ['', [Validators.required]],
      quantity: ['', [Validators.required]]
    });
  }
  addNewRow() {
    // control refers to your form array
    const control = <UntypedFormArray>this.supportAndAccessoriesRequestForm?.get('accesoriesForm')?.get('itemRows');
    //add new formgroup
    control.push(this.initItemRows());
  }
  deleteAccesoriesRequestRow(index: number) {
    // control refers to your formarray
    const control = <UntypedFormArray>this.supportAndAccessoriesRequestForm?.get('accesoriesForm')?.get('itemRows');
    // remove the chosen row
    control.removeAt(index);
  }



  public serial(params: any) {
    var temp = params.data.serialKey;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public merchantId(params: any) {
    var temp = params.data.idMerchant;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public termId(params: any) {
    var temp = params.data.idTerminal;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }
  public contactNo(params: any) {
    var temp = params.data.contactNo1;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
  }

  // get f() {
  //   return this.SupportForm.controls;
  // }

  loadPosHistorysData() {
    this.bankPortalService.bankPortal_GetHistory().subscribe(results => this.onHistoryDataLoadSuccessful(results), error => this.onHistoryDataLoadFailed(error));
  }


  onHistoryDataLoadSuccessful(posHistorys: any) {

    this.rowsCache = [...posHistorys];
    this.rows = posHistorys;
    this.roworiginal = this.rows;
    //console.log(this.rows);
  }


  onHistoryDataLoadFailed(error: any) {
    this._toastr.error("Unable to load data", "Error");
  }

  public actions(bankPortalAuthService: BankPortalAuthService) {
    return function (params: any) {
      if (bankPortalAuthService.hasPermission(Permission.SupportAccessoriesRequest))
        return (`<button type= "button btn-primary btn-sm"  data-action-type="Support"  class="btn-req btn-sm">Request</button> `);
    }
  }

  gridOptions = {
    rowSelection: 'multiple',
    enableSorting: 'true',
    enableColResize: 'true',
    enableRtl: 'true',
    pagination: 'true',
    paginationAutoPageSize: 'true',
    animateRows: 'true',
    rowClicked: 'true'
  }

  public onRowClicked(e) {
    if (e.event.target !== undefined) {
      let data = e.data;

      let actionType = e.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "Support":
          return this.SupportSelect(data);

      }
    }
  }
  private SupportSelect(row: any) {
    if (row.isSupportPresent == true) {
      this.uploadType = 2;
      this.radioItems = [{ id: 2, type: "Accessories Request" }];
    }
    else {
      this.uploadType = 1;
      this.radioItems = [
        { id: 1, type: "Support Request" },
        { id: 2, type: "Accessories Request" },
        { id: 3, type: 'Both' }];

    }

    this.supportAndAccessoriesRequestForm.reset();
    this.submitted = false;
    this.AddSupport(row);
  }
  AddSupport(row: any) {
    this.addSupport = true;
    this.editRow = row;

  }


  onSupport() {
    console.log(this.merchantAccessoriesReq);
    switch (this.uploadType) {
      case 1: {
        this.merchantSupportReq.submitted = true;
        if (this.merchantSupportReq.supportForm.invalid)
          return;
        this.isReqSave = true;

        const supportRequest = CreateSupportCommand.fromJS(this.merchantSupportReq.supportForm.value);
        supportRequest.deploymentRequestId = this.editRow.deploymentRequestId;
        supportRequest.isFieldSupport = this.merchantSupportReq.supportForm.value.isFieldSupport === '1' ? true : false;

        this.bankPortalService.bankPortal_CreateSupport(supportRequest)
          .subscribe(
            results => {
              this._toastr.success("Support request created successfully", "Success");
              this.loadPosHistorysData();
              this.addSupport = false;
            },
            error => {
              this._toastr.error("An error occured while adding support request", "Request Error");
            },
            () => {
              this.isReqSave = false;
              //   this.SupportForm.reset();
              this.submitted = false;
              this.supportEdit = new SupportEdit();
            });
        break
      }
      case 2: {
        this.merchantAccessoriesReq.submitted = true;
        if (this.merchantAccessoriesReq.accessoriesRequestForm.invalid)
          return;

        const accessoriesRequest = new MerchantAccessoriesRequestViewModel();
        accessoriesRequest.deploymentRequestId = this.editRow.deploymentRequestId;
        accessoriesRequest.accessioresList =
          this.merchantAccessoriesReq.accessoriesRequestForm.value.itemRows?.map(x => Accessories.fromJS(x));

        //Array.from(this.merchantAccessoriesReq.accessoriesRequestForm.value.itemRows);


        this.bankPortalService.bankPortal_PostMerchantAccessoriesRequest(accessoriesRequest)
          .subscribe(results => {
            this._toastr.success("Accessories Request created successfully", "Success");
            this.loadPosHistorysData();
            this.addSupport = false;
          },
            error => {
              this._toastr.error(`An error occured while adding accessories request`, "Request Error");
            },
            () => {
              this.isReqSave = false;
              this.supportEdit = new SupportEdit();
            });
        break;
      }
      case 3: {
        this.submitted = true;
        if (this.supportAndAccessoriesRequestForm.invalid)
          return;

        const supportAndAccessoriesReq = new MerchantAccessoriesAndSupportRequestVm();
        supportAndAccessoriesReq.deploymentRequestId = this.editRow.deploymentRequestId;
        if (this.supportAndAccessoriesRequestForm.value.supportForm.priority === null) {
          const supportForm = this.supportAndAccessoriesRequestForm.get('supportForm') as UntypedFormGroup;
          supportForm.controls['priority'].setValue(false);
        }
        supportAndAccessoriesReq.supports = MerchantSupport.fromJS(this.supportAndAccessoriesRequestForm.value.supportForm);
        supportAndAccessoriesReq.accessioresList =
          this.supportAndAccessoriesRequestForm.value.accesoriesForm.itemRows?.map(x => Accessories.fromJS(x));
        supportAndAccessoriesReq.supports.isFieldSupport =
          this.supportAndAccessoriesRequestForm.value.supportForm.isFieldSupport === '1' ? true : false;



        this.bankPortalService.bankPortal_PostMerchantSupportAndAccessoriesRequest(supportAndAccessoriesReq)
          .subscribe(results => {
            this._toastr.success("Support and Accessories Request created successfully", "Success");
            this.loadPosHistorysData();
            this.addSupport = false;
          },
            error => {
              // this._toastr.stopLoadingMessage();
              // this.loadingIndicator = false;

              this._toastr.error(`An error occured while adding Accessories & Support request`, "Request Error");
            },
            () => {
              this.isReqSave = false;
              this.supportEdit = new SupportEdit();
            });
        break;
      }
    }



  }
  hide() {
    this.addSupport = false;
    this.submitted = false;
    this.uploadType = 3;
    this.supportAndAccessoriesRequestForm.reset();
    this.merchantAccessoriesReq.accessoriesRequestForm.reset();
    this.merchantSupportReq.supportForm.reset();
  }

  onSearchChanged(value: string) {
    this.rows = this.rowsCache.filter(r => Utilities.searchArray(value, false, r.merchant, r.idMerchant, r.idTerminal, r.item, r.address, r.contactPerson, r.serialKey));
  }


  deleteRow(index) {
    if (this.editIndex == index) {
      this._toastr.show(`It can't be delete as it is open in Edit Mode `, "Sorry");
    }
    else {
      this.addedRow.splice(index, 1);
      this._toastr.show(`Request Deleted !!`, "");

    }

  }

  edit(index) {
    this.isUpdate = true;
    this.editted = true;
    this.editIndex = index;
  }

  goToBottom() {
    const el: HTMLDivElement = this._el.nativeElement;
    el.scrollTop = Math.max(0, el.scrollHeight - el.offsetHeight);

  }
  onScroll(event: any) {

    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {

    }
  }

  setradio(e: string): void {
    //debugger;
    if (e == "phone") {
      this.selectedLink = e;
      this.showRadioButton = true;
      this.supportEdit.phone = true;
      this.supportEdit.field = false;
    }
    else if (e == "field") {
      this.selectedLink = e;
      this.showRadioButton = true;
      this.supportEdit.phone = false;
      this.supportEdit.field = true;
    }
    else {
      this.showRadioButton = true;
      this.supportEdit.phone = false;
      this.supportEdit.field = false;
    }
  }


  // setradio(e: string): void {
  //   //debugger;
  //   if (e === "phone") {
  //     this.selectedLink = e;
  //     this.showRadioButton = true;
  //     this.supportEdit.phone = true;
  //     this.supportEdit.field = false;
  //   } else if (e === "field") {
  //     this.selectedLink = e;
  //     this.showRadioButton = true;
  //     this.supportEdit.phone = false;
  //     this.supportEdit.field = true;
  //   } else {
  //     this.showRadioButton = false;
  //     this.supportEdit.phone = false;
  //     this.supportEdit.field = false;
  //   }
  // }
  loadTerminalData() {
    //this.inventory.hasSerialNo = true;
    this.bankPortalService.bankPortal_GetSparesDataInfo().subscribe(results => this.onDataLoadSuccessfulInventory(results), error => this.onDataLoadFailedInventory(error));
  }
  onDataLoadSuccessfulInventory(inventorys: AccessoryViewModel[]) {
    this.accessoriesList = inventorys;
  }
  onDataLoadFailedInventory(error: any) {
    // this.alertService.stopLoadingMessage();
    //this.loadingIndicator = false;

  }

  numericOnly(event): boolean {
    let patt = /^([1-9][0-9]*)$/;
    let result = patt.test(event.key);
    return result;
  }
  uploadTypeChange(value) {
    this.uploadType = value.id;
    this.submitted = false;
    this.supportAndAccessoriesRequestForm.reset();
  }

  public connectivityType(connectivityList) {
    return function action(params) {
      if (params.data.connectivities != null) {
        var idString = params.data.connectivities.toString();
        let ids = idString.split(",");
        ids = ids.map(x => +x);
        var temp = connectivityList.filter((f: { value: any; }) => ids.includes(f.value));
        var temp1 = temp.map(x => x.option).join();
        return temp1;
      }
      else {
        return params.data.connectivities;
      }
    }
  }

  onModelUpdated() {
    setTimeout(() => { this.gridColumnApi.autoSizeAllColumns() });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.quickSearchValue)
  }

}
